var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.user)?_c('v-chip',{staticClass:"chip--select-multi"},[_c('v-avatar',[(_vm.user)?_c('img',{attrs:{"src":_vm.userImg(_vm.user.userImage, false)}}):_vm._e()]),_vm._v(" "+_vm._s(_vm.user.fName)+" ")],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }